var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"id":"dashboard-view","fluid":"","tag":"section"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"logo-sun-wrapper"},[_c('img',{staticClass:"logo-sun-main",attrs:{"src":require("@/assets/sun.png"),"alt":""}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }